import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { closeCustomDialogAction } from 'redux/slices/customDialogSlice';
import { editProductAction } from 'redux/slices/productSlice';
import ProductForm from './ProductForm';

const ProductEdit = (props) => {
    const { loadData, product, readOnly, formConfigProduct, formConfigProductVariant, canEdit, onCancel, onComplete } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const handleSubmit = (data, callback) => {
        data.description = data.descriptionHtml;
        dispatch(
            editProductAction(product.variantGroupId || product.id, data, (product) => {
                try {
                    onComplete?.(product);
                } catch (error) {
                    console.error(`Error calling product edit onComplete callback: ${error.message}`);
                }
                callback();
                loadData?.();
                dispatch(closeCustomDialogAction());
            }),
        );
    };

    return (
        <ProductForm
            readOnly={readOnly}
            action={t('product.productEdit.edit')}
            product={product}
            onSubmit={handleSubmit}
            formConfigProduct={formConfigProduct}
            formConfigProductVariant={formConfigProductVariant}
            canEdit={canEdit}
            onCancel={onCancel}
        />
    );
};

export default ProductEdit;
